<form #form="ngForm">
    <div *ngIf="formulaireOmpService.paramOmp as paramOmp; else loading">
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.omp.parametrage'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="actif"
                            name="actif"
                            [ngModel]="paramOmp.actif"
                            [(customModel)]="paramOmp.actif"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.omp.actif"
                            postLibelle="admin.parametres.formulaire.omp.actifPost"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.omp.generalites'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="isPeriodeAnInterdit"
                            name="isPeriodeAnInterdit"
                            [ngModel]="paramOmp.periodeAnInterdit"
                            [(customModel)]="paramOmp.periodeAnInterdit"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.omp.interdirePeriode"
                            postLibelle="admin.parametres.formulaire.omp.interdirePeriodePost"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            id="exerciceChevalInterdit"
                            name="exerciceChevalInterdit"
                            [ngModel]="paramOmp.exerciceChevalInterdit"
                            [(customModel)]="paramOmp.exerciceChevalInterdit"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.omp.interdireExercice"
                            postLibelle="admin.parametres.formulaire.omp.interdireExercicePost"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="paramOmp.dateDebut"
                            [selectOptions]="dateDebutOptionListe"
                            libelle="admin.parametres.formulaire.omp.dateDebut"
                            name="dateDebut"
                            optionDisplay="libelle"
                            optionValue="type"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="paramOmp.dateFin"
                            [selectOptions]="dateFinOptionListe"
                            libelle="admin.parametres.formulaire.omp.dateFin"
                            name="DateFin"
                            optionDisplay="libelle"
                            optionValue="type"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <floating-button [listeActions]="listeActions" [isPending]="formulaireOmpService.isSaving"></floating-button>
    </div>
</form>

<!--Affiché si on a pas encore le modèle-->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>